import { axios } from '../util'

const GET_TOKEN_EMAIL_ENDPOINT = '/2fa/v0/login/selfservice/info'

export const getUserEmail = token => {
  return axios
    .get(GET_TOKEN_EMAIL_ENDPOINT, {
      withCredentials: false,
      headers: {
        Authorization: token,
      },
    })
    .then(({ data }) => data.email)
}
